module.exports = __webpack_public_path__ + "img/nasida-loader.0d277604.svg";